/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2023-06-13 21:16:46
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-08-13 14:41:28
 * @FilePath: \baishu_react_ui\src\components\BsyFlowComment\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';
import {BsyUtils} from '../../utils/Utils';

import './index.css';
import {BsyWidget} from '../BsyWidget';
import classNames from 'classnames';

class BsyFlowComment extends BsyWidget {
    constructor(props) {
        super({
            baseCls: "bsy-flow-comment",
            appId: null,
            entryId: null,
            comments: [],
            isPrint: !1,
            onAfterClose: null,
            ...props,
        });
        this.state = {
            ...props
        }

    }

    componentDidMount() {

    }

    renderMenu = (item) => {

        return (<div className="comment-menu">
            <div className="menu-creator">{item.operator}</div>
            <div className="menu-time">{BsyUtils._formatDate(item.createTime)}</div>
            <div className="menu-state">{item.flowName}</div>
        </div>)
    }

    renderContent = (item) => {

        let url = "";
        if (item.signature && item.signature.length > 0) {
            url = BsyUtils.getfiledownloadURL(item.signature[0],{})
        }

        return (<div className="content">
            {
                item.comment ? <span>{item.comment}</span> : ''
            }
            {
                url ? <img src={url} alt={''} /> : ''
            }

        </div>)
    }

    render() {

        const { comments  } = this.props;
        const {baseCls, customCls} = this.options
        let coms = comments.filter((item, index) => {
            return (!BsyUtils.isEmpty(item.comment) || !BsyUtils.isObjectEmpty(item.signature)) && "save" !== item.flowAction;
        })

        if (coms.length == 0) {
            return '';
        }

        return (
            <div className={classNames(baseCls,customCls )}>
                <div className="comment-content">
                    <div className="comment-title"><span>{React.language('form.comment')}</span></div>
                    <ul className="comment-list">
                        {
                            coms.map(item => {

                                if ((!BsyUtils.isEmpty(item.comment) || !BsyUtils.isObjectEmpty(item.signature)) && "save" !== item.flowAction) {
                                    return <li li className="comment-item">
                                        {
                                            this.renderMenu(item)
                                        }
                                        {
                                            this.renderContent(item)
                                        }
                                    </li>
                                }

                                return ''
                            })

                        }

                    </ul>
                </div>
            </div>

        );
    }
}

export default BsyFlowComment;
